import { MatDialogConfig } from '@angular/material/dialog';

export const BENUTZER_HINZUFUEGEN_DIALOG_PANEL_CLASS = 'benutzer-hinzufuegen-dialog-panel';

export function buildBenutzerHinzufuegenDialogConfig(isMobile = false): MatDialogConfig {
    return {
        width: isMobile ? 'calc(100vw - 24px)' : '700px',
        maxWidth: isMobile ? 'calc(100vw - 24px)' : '95vw',
        panelClass: BENUTZER_HINZUFUEGEN_DIALOG_PANEL_CLASS,
    };
}
